import { Thunder } from '@goodlok/sdk/generated/content_role_website'
import { fromThunderWithToken } from '../fromThunder'

export const publicZeus = fromThunderWithToken(Thunder, {
	url: `${process.env.BACKEND_URL}/content`,
})(String(process.env.NEXT_PUBLIC_CONTEMBER_CONTENT_KEY))
